import { convertWidth } from './convertWidth';
export function convertWidthToPPM(peaks, options) {
    return convertWidth(peaks, { ...options, convertTo: 'ppm' });
}
//# sourceMappingURL=convertWidthToPPM.js.map